import { addDataLayerEntry, Events } from '@printdeal/data-layer-manager';

const eventCategory = 'login_form';

export const dispatchDataLayerLoginPromptView = (pagePath = 'home') => {
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory,
      eventAction: `display_prompt_path : ${pagePath}`,
      eventNonInteraction: true,
    },
  });
  addDataLayerEntry(eventCategory, {
    eventAction: `display_prompt_path : ${pagePath}`,
    eventNonInteraction: true,
  });
};

export const dispatchDataLayerLoginPromptRegister = () => {
  addDataLayerEntry(Events.Event, {
    gaEvent: {
      eventCategory,
      eventAction: 'create_account',
    },
  });
  addDataLayerEntry(eventCategory, {
    eventAction: 'create_account',
    eventLabel: 'homepage',
  });
};
